import React, { Component } from 'react'
import Collapsible from '../Collapsible'
import CheckBox from '../../components/CheckBox'
import DropdownTreeSelect from "react-dropdown-tree-select"
import isEqual from 'lodash/isEqual'

class FilterIndustry extends Component {
  constructor(props){
    super(props)
    this.state = { filterCategories: props.filterCategories, currentNode: 1 }
  }

  componentWillReceiveProps = (nextProps) => {
    if(!isEqual(nextProps.filterCategories, this.state.filterCategories) || nextProps.selectedIndustryIds.length <= 1 || this.state.currentNode == 0) {
      this.setState({ filterCategories: nextProps.filterCategories, currentNode: 1 })
    }
  }

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.filterCategories, this.state.filterCategories) || nextProps.selectedIndustryIds.length <= 1 || this.state.currentNode == 0
  }

  industryChanged = (isChecked, selectedValue) => {
    this.setState({currentNode: selectedValue})
    this.props.onChange({checked: isChecked, value: selectedValue}, [])
  }

  getChildren = (industries, parentId, gParentId) => {    
    const ind = (industries
      .filter(x => x.parentId === parentId)
      .map(c => { return { value: c.id, label: c.name, children: this.getChildren(industries, c.id, parentId), checked: this.shouldBeChecked(industries, c.id, c.parentId) }})
      .sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)))
    
    return ind
  }

  shouldBeChecked(industries, currentId, parentId) {
    if(this.props.selectedIndustryIds.includes(currentId)) {
      return true
    } else {
      let parentNode = industries.filter(x => x.id === parentId)
      if (parentNode.length > 0) {
        this.shouldBeChecked(industries, parentNode[0].id, parentNode[0].parentId)
      } else {
        return false
      }
    }
  }

  render() {
    // Get distinct all industries
    const { filterCategories, selectedIndustryIds, ...rest } = this.props

    const industries = this.props.filterCategories.filter(c => c.type === 3)

    const distinctIndustries = Array.from(new Set(industries.map(cat => cat.id)))
      .map(categoryId => {
        return industries.find(c => c.id === categoryId)
      })

    const parentIndustries = (distinctIndustries
      .filter(x => x.parentId === 0)
      .map(c => { return { value: c.id, label: c.name, children: this.getChildren(distinctIndustries, c.id, 0),
        checked: this.props.selectedIndustryIds.includes(c.id)} })
      .sort((a, b) => a.label != null && b.label != null && a.label.localeCompare(b.label)))

    return (
      (parentIndustries.length > 0) ?
        <Collapsible title='Industry' titleClassName='box-header' id='indus'>
          <div className='box-industries'>
            <div className='div-separator'>
            <CheckBox
                id='cbIndustryAll'
                Name='cbIndustryAll'
                Checked={this.props.selectedIndustryIds.length === 0}
                onTickChanged={(chk, val) => this.industryChanged(chk, val)}
                Value='0' text='Show All'
              />
            </div>

            <DropdownTreeSelect id="Industries" name="industries" data={parentIndustries} showPartiallySelected={true} 
              showDropdown='always' texts={{ placeholder: 'Search within Industries' }} {...rest} />
          </div>
        </Collapsible>
        : null
    )
  }
}

export default FilterIndustry
